"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const express_1 = tslib_1.__importDefault(require("express"));
const platform_express_1 = require("@nestjs/platform-express");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const file_upload_dto_1 = require("./dto/file-upload.dto");
const file_upload_service_1 = require("./file-upload.service");
const file_upload_swagger_1 = require("./file-upload.swagger");
let FileUploadController = class FileUploadController {
    constructor(fileUploadService) {
        this.fileUploadService = fileUploadService;
    }
    /**
     * Accepts a file through a POST request and processes it using the fileUploadService.
     */
    async uploadFile(file, body, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            if (!file) {
                throw new common_1.BadRequestException("File is required");
            }
            const result = await this.fileUploadService.uploadFile(file, body.companyType.toLowerCase(), parseInt(body.companyId, 10), body.documentTypeLid, userId);
            return result;
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, null, messages_1.errorMessages.fileUploadFailed, messages_1.errorMessages.fileForbidden, messages_1.errorMessages.fileNotFound);
        }
    }
    async deleteFile(fileId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            if (!fileId) {
                throw new common_1.BadRequestException("File ID is required");
            }
            const result = await this.fileUploadService.deleteFile(fileId, userId);
            return {
                status: common_1.HttpStatus.OK,
                message: result.message,
                data: result.data,
            };
        }
        catch (error) {
            console.error("Error during file deletion:", error);
            if (error instanceof common_1.NotFoundException) {
                return {
                    status: common_1.HttpStatus.NOT_FOUND,
                    message: error.message,
                };
            }
            if (error instanceof common_1.BadRequestException) {
                return {
                    status: common_1.HttpStatus.BAD_REQUEST,
                    message: error.message,
                };
            }
            return {
                status: common_1.HttpStatus.INTERNAL_SERVER_ERROR,
                message: error.message || "File deletion failed",
            };
        }
    }
    /**
     * Replaces a file on the server based on the provided ID and file.
     */
    async replaceFileFromServer(documentId, file, body, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            if (!documentId) {
                throw new common_1.BadRequestException("File ID is required");
            }
            if (!file) {
                throw new common_1.BadRequestException("File is required");
            }
            return this.fileUploadService.replaceFileFromServer(documentId, file, userId, body);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.fileReplaceFailed);
            }
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error instanceof Error ? error.message : messages_1.errorMessages.fileReplaceFailed);
        }
    }
    async download(documentId, res) {
        try {
            const result = await this.fileUploadService.download(documentId);
            // Set headers for download
            res.setHeader("Content-Disposition", `attachment; filename="${result.fileName}"`);
            res.setHeader("Content-Type", result.mimeType || "application/octet-stream");
            if (result.contentLength) {
                res.setHeader("Content-Length", result.contentLength);
            }
            res.setHeader("Access-Control-Expose-Headers", "Content-Disposition");
            // Pipe the stream to the response
            result.stream.pipe(res);
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException ||
                error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.BadRequestException("Failed to download document");
        }
    }
};
exports.FileUploadController = FileUploadController;
tslib_1.__decorate([
    (0, common_1.Post)("upload"),
    (0, file_upload_swagger_1.uploadFileSwaggerMetadata)(),
    (0, common_1.UseInterceptors)((0, platform_express_1.FileInterceptor)("file")),
    tslib_1.__param(0, (0, common_1.UploadedFile)()),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof Express !== "undefined" && (_b = Express.Multer) !== void 0 && _b.File) === "function" ? _c : Object, typeof (_d = typeof file_upload_dto_1.CreateFileUploadDto !== "undefined" && file_upload_dto_1.CreateFileUploadDto) === "function" ? _d : Object, typeof (_e = typeof Request !== "undefined" && Request) === "function" ? _e : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], FileUploadController.prototype, "uploadFile", null);
tslib_1.__decorate([
    (0, common_1.Delete)("upload/delete/:fileId"),
    tslib_1.__param(0, (0, common_1.Param)("fileId", common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_f = typeof Request !== "undefined" && Request) === "function" ? _f : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], FileUploadController.prototype, "deleteFile", null);
tslib_1.__decorate([
    (0, common_1.Put)("upload/replace/:documentId"),
    (0, file_upload_swagger_1.replaceFileSwaggerMetadata)(),
    (0, common_1.UseInterceptors)((0, platform_express_1.FileInterceptor)("file")),
    tslib_1.__param(0, (0, common_1.Param)("documentId")),
    tslib_1.__param(1, (0, common_1.UploadedFile)()),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_h = typeof Express !== "undefined" && (_g = Express.Multer) !== void 0 && _g.File) === "function" ? _h : Object, typeof (_j = typeof file_upload_dto_1.CreateFileUploadDto !== "undefined" && file_upload_dto_1.CreateFileUploadDto) === "function" ? _j : Object, typeof (_k = typeof Request !== "undefined" && Request) === "function" ? _k : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], FileUploadController.prototype, "replaceFileFromServer", null);
tslib_1.__decorate([
    (0, common_1.Get)("upload/download/:documentId"),
    tslib_1.__param(0, (0, common_1.Param)("documentId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_l = typeof express_1.default !== "undefined" && express_1.default.Response) === "function" ? _l : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], FileUploadController.prototype, "download", null);
exports.FileUploadController = FileUploadController = tslib_1.__decorate([
    (0, common_1.Controller)("file-upload"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof file_upload_service_1.FileUploadService !== "undefined" && file_upload_service_1.FileUploadService) === "function" ? _a : Object])
], FileUploadController);
